import React, { useEffect } from 'react';
import styled from 'styled-components';
import theme from 'themes';

const NewInput = styled.input`
  position: relative;
  border: none;
  outline: none;
  padding: 0.2rem;
  fontsize: 1rem;
  border-bottom: 1px solid ${theme.colors.tableborder};

  &::placeholder {
    font-size: 16px;
  }
`;
const DebounceInput = ({
  value: initialValue,
  onChange,
  debounce = 500,
  inputRef,
  restrictSpaceFromStart,
  restrictedCharacters = [],
  ...props
}: {
  value: string | number;
  onChange: (value: string | number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inputRef?: any;
  debounce?: number;
  restrictSpaceFromStart?: boolean;
  restrictedCharacters?: string[];
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>): JSX.Element => {
  const [value, setValue] = React.useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value]);
  return (
    <NewInput
      ref={inputRef}
      {...props}
      value={value}
      onChange={(e) => {
        if (restrictedCharacters && !restrictedCharacters.includes(e.target.value.trim())) {
          restrictSpaceFromStart ? setValue(e.target.value.trimStart()) : setValue(e.target.value);
        }
      }}
    />
  );
};

export default DebounceInput;
